/*
 * This a dummy file for when our synchronous renderer nodes feature gates are disabled
 * This file is the conditional import fallback to use when a respective node group's feature gate is false
 *
 * This file is duplicated due to (at the time of writing) conditional imports needing to be pointed to unique files: https://atlassian.slack.com/archives/C07SP6N4FD5/p1748324594958659?thread_ts=1748311964.968589&cid=C07SP6N4FD5
 * When that is fixed, usages of this file should use emptyRendererNodeMapping.tsx instead
 */

const emptyRendererNodeMapping2: import('@atlaskit/renderer').NodeComponentsProps = {};
export default emptyRendererNodeMapping2;
